import { ThemeProvider, createTheme } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";
import Router from "./components/routing/Router";
import { AuthProvider } from "./context/auth";
import { SnackbarAlertProvider } from "./context/snackbarAlert";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "react-hot-toast";
import { DialogsDisplay } from "./hooks/dialogsDisplay";

const theme = createTheme({
    palette: {
        primary: {
            light: "#1d5472",
            main: "#133649",
            dark: "#081820",
            contrastText: "#fff",
            bright: "#0482CAFF",
        },
        alternate: {
            light: "#68ac6b",
            main: "#509153",
            dark: "#3e7040",
            contrastText: "#fff",
        },
        success: {
            light: "#68ac6b",
            main: "#509153",
            dark: "#3e7040",
            contrastText: "#fff",
        },
        secondary: {
            light: "#555",
            main: "#444",
            dark: "#333",
            contrastText: "#fff",
        },

        warning: {
            main: "#EDBD01",
            contrastText: "#fff",
        },

        error: {
            main: "#d40808",
        },

        disabled: {
            main: "#6e6e6e",
        },
    },
});

const queryClient = new QueryClient();

function App({ msalInstance }) {
    return (
        <ThemeProvider theme={theme}>
            <Toaster
                toastOptions={{
                    error: {
                        position: "bottom-right",
                    },
                }}
            />
            <BrowserRouter>
                {/* <MsalProvider instance={msalInstance}> */}
                <SnackbarAlertProvider>
                    <QueryClientProvider client={queryClient}>
                        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                        <AuthProvider>
                            <DialogsDisplay>
                                <Router />
                            </DialogsDisplay>
                        </AuthProvider>
                    </QueryClientProvider>
                </SnackbarAlertProvider>
                {/* </MsalProvider> */}
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
